"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SPECS_FETCH_PENDING = exports.SPECS_FETCH_PENDING = "SPECS_FETCH_PENDING";
var SPECS_FETCH_COMPLETE = exports.SPECS_FETCH_COMPLETE = "SPECS_FETCH_COMPLETE";
var SPECS_FETCH_ERROR = exports.SPECS_FETCH_ERROR = "SPECS_FETCH_ERROR";
var DATA_FETCH_PENDING = exports.DATA_FETCH_PENDING = "DATA_FETCH_PENDING";
var DATA_FETCH_COMPLETE = exports.DATA_FETCH_COMPLETE = "DATA_FETCH_COMPLETE";
var DATA_FETCH_ERROR = exports.DATA_FETCH_ERROR = "DATA_FETCH_ERROR";
var DOCUMENT_DATA_FETCH_COMPLETE = exports.DOCUMENT_DATA_FETCH_COMPLETE = "DOCUMENT_DATA_FETCH_COMPLETE";
var DOCUMENT_DATA_FETCH_PENDING = exports.DOCUMENT_DATA_FETCH_PENDING = "DOCUMENT_DATA_FETCH_PENDING";
var DOCUMENT_DATA_FETCH_ERROR = exports.DOCUMENT_DATA_FETCH_ERROR = "DOCUMENT_DATA_FETCH_ERROR";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/mdms/actionTypes.js
// module id = ../lib/egov-ui-kit/redux/mdms/actionTypes.js
// module chunks = 504